// src: https://stackoverflow.com/a/35375045/3670829
export const hasWindow = (): boolean => typeof window !== 'undefined';

// src: https://github.com/airbnb/lottie-web/issues/440#issuecomment-338057030
export const hasNavigator = (): boolean => typeof navigator !== 'undefined';

export const hasDocument = (): boolean => typeof document !== 'undefined';
